import { cloneDeep } from 'lodash';

export const createError = (
  prevStateError: Record<string, unknown>,
  actionError: Record<string, unknown>,
) => {
  const ERRORS = cloneDeep(prevStateError);

  const error = (actionError as any)?.error ? (actionError as any).error : actionError;

  /** Creating error for reducer */

  // if (actionError?.type) {
  //   if(actionError?.status > 399 || actionError?.message || actionError?.isAxiosError){
  //     ERRORS[actionError.type as keyof typeof ERRORS] = {
  //       ...actionError,
  //       message: actionError.message, // Shallow copy is enough because there are no nested keys
  //     };
  //   } else {
  //     ERRORS[actionError.type as keyof typeof ERRORS] = undefined;
  //   }
  // }

  if ((error as any)?.type) {
    ERRORS[(error as any)?.type as keyof typeof ERRORS] = {
      ...(error as any),
      message: (error as any)?.message,
    };
  }
  return ERRORS;
};
